import logger from '../common/logger'
import PlatformAPIHttpClient from '../clients/platformAPIHttpClient'
const VwoMappings = {
  'Select Bundle': {
    goal: 'addToCart',
    property: 'bundleid',
  },
  'Shipping Info': {
    goal: 'shippingInformation',
  },
  'Shipping Method': {
    goal: 'shippingMethod',
  },
  'View Pop Sale': {
    goal: 'viewPopupUpsell',
  },
  'View Inline Upsell': {
    goal: 'viewInlineUpsell',
  },
  'Initiate Checkout': {
    goal: 'initiateCheckout',
  },
  'Start Checkout': {
    goal: 'startCheckout',
  },
  'Order Conversion': {
    goal: 'conversion',
    property: 'revenue',
  },
  'Post Transaction Conversion 1': {
    goal: 'postPurchase1',
    property: 'revenue',
  },
  'Post Transaction Conversion 2': {
    goal: 'postPurchase2',
    property: 'revenue',
  },
  'Post Transaction Conversion 3': {
    goal: 'postTransaction3',
    property: 'revenue',
  },
}

const hyphensToSpaces = (str) => {
  return str.replace(/-/g, ' ').replace(/ {3,}/g, ' - ')
}

const module = 'VwoTracker'
const VwoTracker = {
  enabled: false,
  vwoReqId: '',
  load: (vwoEnabled, pageType) => {
    if (!vwoEnabled) {
      return
    }

    // TODO: This is currently handled by the Craft FE, but should
    // be moved here eventually.
    // VwoTracker.loadMainScript()

    window.VWO = window.VWO || []
    window.VWO.event =
      window.VWO.event ||
      function () {
        window.VWO.push(['event'].concat([].slice.call(arguments)))
      }
    window.VWO.visitor =
      window.VWO.visitor ||
      function () {
        window.VWO.push(['visitor'].concat([].slice.call(arguments)))
      }

    VwoTracker.getVwoReqId()
    VwoTracker.enableRealTimeTracking()

    if (!VwoTracker.vwoReqId || VwoTracker.vwoReqId === '') {
      window.VWO.visitor({ gu_uuid: window.gu_id })

      let attempts = 0
      const reqIdChecker = setInterval(function () {
        VwoTracker.getVwoReqId()

        if (
          (!VwoTracker.vwoReqId || VwoTracker.vwoReqId === '') &&
          attempts < 10
        ) {
          attempts++
          return
        }

        window.VWO.visitor({
          gu_uuid: window.gu_id,
          reqid: VwoTracker.vwoReqId,
        })

        clearInterval(reqIdChecker)
      }, 250)
    } else {
      window.VWO.visitor({ gu_uuid: window.gu_id, reqid: VwoTracker.vwoReqId })
    }

    const vwo_landing_pages = {
      offer: 'landingPage',
      presell: 'presell_landing_event',
      splash: 'vsl_landing_event',
    }
    if (typeof vwo_landing_pages[pageType] !== 'undefined') {
      const vwoProperty = {
        req_id: VwoTracker.vwoReqId,
      }
      window.VWO.event(vwo_landing_pages[pageType], vwoProperty)
    }
  },
  /**
   * Loads the main script for VWO 360 Async SmartCode.
   * @function loadMainScript
   */
  loadMainScript: function () {
    /* VWO 360 Async SmartCode */
    window._vwo_code =
      window._vwo_code ||
      (function () {
        var account_id = 652732,
          version = 1.3,
          settings_tolerance = 2000,
          library_tolerance = 2500,
          use_existing_jquery = false,
          is_spa = 1,
          hide_element = 'body',
          /* DO NOT EDIT BELOW THIS LINE */
          f = false,
          d = document,
          code = {
            use_existing_jquery: function () {
              return use_existing_jquery
            },
            library_tolerance: function () {
              return library_tolerance
            },
            finish: function () {
              if (!f) {
                f = true
                var e = d.getElementById('_vis_opt_path_hides')
                if (e) e.parentNode.removeChild(e)
              }
            },
            finished: function () {
              return f
            },
            load: function (e) {
              var t = d.createElement('script')
              t.fetchPriority = 'high'
              t.src = e
              t.type = 'text/javascript'
              t.innerText
              t.onerror = function () {
                window._vwo_code.finish()
              }
              d.getElementsByTagName('head')[0].appendChild(t)
            },
            init: function () {
              window.settings_timer = setTimeout(function () {
                window._vwo_code.finish()
              }, settings_tolerance)
              var e = d.createElement('style'),
                t = hide_element
                  ? hide_element +
                    '{opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;}'
                  : '',
                i = d.getElementsByTagName('head')[0]
              e.setAttribute('id', '_vis_opt_path_hides')
              e.setAttribute('nonce', document.querySelector('#vwoCode').nonce)
              e.setAttribute('type', 'text/css')
              if (e.styleSheet) e.styleSheet.cssText = t
              else e.appendChild(d.createTextNode(t))
              i.appendChild(e)
              this.load(
                'https://dev.visualwebsiteoptimizer.com/j.php?a=' +
                  account_id +
                  '&u=' +
                  encodeURIComponent(d.URL) +
                  '&f=' +
                  +is_spa +
                  '&vn=' +
                  version
              )
              return window.settings_timer
            },
          }
        window._vwo_settings_timer = code.init()
        return code
      })()
  },
  checkVwoCookie: () => {
    if (window.VWO._ && window.VWO._.cookies) {
      let cookies = window.VWO._.cookies.getAll()
      let vwoCookies = Object.keys(cookies).filter(
        (key) =>
          key.startsWith('_vis_opt_exp') &&
          (key.endsWith('_combi') || key.endsWith('_exclude'))
      )
      if (vwoCookies.length > 0) {
        return true
      }
    }
    return false
  },
  enableRealTimeTracking: () => {
    var vwo_account_id = ''
    // let vwo_uuid = ''
    window.VWO = window.VWO || []
    window.VWO.push([
      'onVariationApplied',
      function (data) {
        vwo_account_id = window._vwo_acc_id
        var experiment_id = data[1],
          variant_id = data[2]
        //exp_name = data[4]

        //vwo_uuid =
        //  window.VWO._ &&
        //  window.VWO._.cookies &&
        //  window.VWO._.cookies.get('_vwo_uuid')

        if (
          window._vwo_exp[experiment_id].comb_n[variant_id] &&
          ['VISUAL_AB', 'VISUAL', 'SPLIT_URL'].indexOf(
            window._vwo_exp[experiment_id].type
          ) > -1
        ) {
          var vwo_data = {
            req_id: VwoTracker.vwoReqId,
            experiment_name: window._vwo_exp[experiment_id].name,
            experiment_id: experiment_id,
            account_id: vwo_account_id,
            variation_id: variant_id,
            variation_name: hyphensToSpaces(
              window._vwo_exp[experiment_id].comb_n[variant_id]
            ),
            user_id: window.gu_id,
          }
          // Send to backend
          PlatformAPIHttpClient.postVwoDataAsync(vwo_data)
        }
      },
    ])
  },

  getVwoReqId() {
    if (window.gu_qs !== undefined && window.gu_qs.req_id) {
      VwoTracker.vwoReqId = window.gu_qs.req_id
    } else {
      VwoTracker.vwoReqId =
        window.location.href.toLowerCase().indexOf('req_id') > -1
          ? window.location.href
            .split('?')[1]
            .toLowerCase()
            .split('req_id=')[1]
            .split('&')[0]
          : ''
    }
  },

  trackEvent: (eventProperties) => {
    if (!window._vwo_code) {
      return
    }
    try {
      // @TODO Remove two lines below after full migration to this library
      window.VWO = window.VWO || []
      window.VWO.event =
        window.VWO.event ||
        function () {
          window.VWO.push(['event'].concat([].slice.call(arguments)))
        }

      const eventName = eventProperties.eventName
      if (VwoMappings?.[eventName]) {
        const vwoGoal = VwoMappings[eventName].goal

        let vwoProperty = {
          req_id: VwoTracker.vwoReqId,
          gu_uuid: window.gu_id,
        }

        if (VwoMappings[eventName].property) {
          const propertyName = VwoMappings[eventName].property
          const propertyValue =
            eventProperties.propertyValue || VwoMappings[eventName].value
          vwoProperty[propertyName] = propertyValue

          if (VwoMappings[eventName].property === 'revenue') {
            vwoProperty.order_id =
              eventProperties.propertyMeta?.friendly_id ||
              eventProperties.propertyMeta?.id
          }
        }

        // add tracking event
        window.VWO.event(vwoGoal, vwoProperty)
      }
    } catch (e) {
      logger.error('trackEvent Failed', e, { module })
    }
  },
}
export default VwoTracker
